module.exports = __webpack_public_path__ + "mobile-logo.svg?10dc0bef44e969afe2bdcf8fb9692605";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile-logo.svg
// module id = 174
// module chunks = 0